export const auth0Config = {
  client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};


// see .env.production and .env.development for configurations
//  and install    npm install env-cmd --save-dev
export const appSettings = {
  webApi: process.env.REACT_APP_WEB_API,
  authRedirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI
};
/*
export const appSettings = {
  //*****PROD*******
  //webApi: "https://teroteckapi-alstom.azurewebsites.net/api/v1/",
  //authRedirectUri: "https://terotech-alstom.azurewebsites.net/login" 

  //*****DEV*******
  webApi: "https://localhost:44351/api/v1/",
  authRedirectUri: "http://localhost:3000/login"
}
*/